// src/components/common/LoadingSpinner/LoadingSpinner.js - Updated with new color scheme
import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { COLORS } from '../../../utils/color';

const LoadingSpinner = ({ message = 'Loading...', size = 40 }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        gap: 2,
      }}
    >
      <CircularProgress 
        size={size} 
        sx={{ color: COLORS.primary.main }} 
      />
      <Typography 
        variant="body1" 
        sx={{ color: COLORS.text.secondary, textAlign: 'center' }}
      >
        {message}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;